require('./cardLastMovements.scss');

const React = require('react');
const PropTypes = require('prop-types');
const CardLastMovementsFilter = require('components/cards/cardLastMovements/cardLastMovementsFilter/cardLastMovementsFilter');
const CardLastMovementsContent = require('components/cards/cardLastMovements/cardLastMovementsContent/cardLastMovementsContent');
const { EURO_TEXT } = require('../../../constants');

class CardLastMovements extends React.Component {
    constructor (props) {
        super(props);

        this.state = {
            filterSettingsOpen: false
        };

        this.clearFilters = this.clearFilters.bind(this);
        this.setFilters = this.setFilters.bind(this);
        this.handleToggleFilters = this.handleToggleFilters.bind(this);
        this.getTransactions = this.getTransactions.bind(this);
        this.handleRetry = this.handleRetry.bind(this);
        this.resetFilter = this.resetFilter.bind(this);
    }

    componentDidMount() {
        this.getTransactions();
    }

    componentWillReceiveProps(nextProps){
        const { immCard, requestCardTransactions, showCardsDropdown } = this.props;
        const { immCard: immNextCard } = nextProps;
        const cardId = immNextCard.get('cardId');

        if (showCardsDropdown && cardId && cardId !== immCard.get('cardId')) {
            requestCardTransactions(cardId);
        }
    }

    componentWillUnmount() {
        const {
            cardTransactionsOutdated,
            clearFilters,
            showCardsDropdown,
        } = this.props;

        clearFilters(false);
        if (showCardsDropdown){
            cardTransactionsOutdated();
        }
    }

    getTransactions() {
        const {immCard, immTransactions, requestCardTransactions} = this.props;

        if (!immTransactions || !!immTransactions.get('error') || immTransactions.get('isOutdated')) {
            requestCardTransactions(immCard.get('cardId'));
        }
    }

    clearFilters() {
        const { clearFilters, immCard, requestCardTransactions } = this.props;

        clearFilters();
        requestCardTransactions(immCard.get('cardId'));
    }

    resetFilter(filter) {
        const { immCard, requestCardTransactions, resetFilter } = this.props;

        resetFilter(filter);
        requestCardTransactions(immCard.get('cardId'));
    }

    setFilters(filters) {
        const { immCard, requestCardTransactions, setTransactionsFilters } = this.props;

        this.handleToggleFilters(); //close filters window, then apply filters
        setTransactionsFilters(filters);
        requestCardTransactions(immCard.get('cardId'));
    }

    handleRetry() {
        this.getTransactions();
    }

    handleToggleFilters() {
        this.setState({
            filterSettingsOpen: !this.state.filterSettingsOpen
        });
    }

    render () {
        const {
            downloadCardsTransactions,
            flagBasedFeatures,
            immCard,
            immCards,
            immCardsTransactionsDownload,
            immFilters,
            immProfile,
            immTransactions,
            requestCardTransactions,
            requestNextCardTransactionsPage,
            showCardsDropdown,
            validateAndExecuteSagas,
            resetScaForCardTransactionsDownload
        } = this.props;

        let innerComponent;
        if (!!immTransactions) {
            innerComponent = (
                <CardLastMovementsContent
                    clearFilters={this.clearFilters}
                    defaultLanguage={immProfile.get('originCountry').toLowerCase()}
                    downloadCardsTransactions={downloadCardsTransactions}
                    flagBasedFeatures={flagBasedFeatures}
                    immCard={immCard}
                    immCards={immCards}
                    immCardsTransactionsDownload={immCardsTransactionsDownload}
                    immFilters={immFilters}
                    immProfile={immProfile}
                    immTransactions={immTransactions}
                    onFilterClick={this.handleToggleFilters}
                    onRetry={this.handleRetry}
                    requestCardTransactions={requestCardTransactions}
                    requestNextCardTransactionsPage={requestNextCardTransactionsPage}
                    resetFilter={this.resetFilter}
                    showCardsDropdown={showCardsDropdown}
                    validateAndExecuteSagas={validateAndExecuteSagas}
                    resetScaForCardTransactionsDownload={resetScaForCardTransactionsDownload}
                />
            );
        }

        let modal;

        if (this.state.filterSettingsOpen) {
            const cardCurrency =immFilters.getIn(['amount', 'from', 'currency']);
            modal = (
                <CardLastMovementsFilter
                    immCard={immCard}
                    immFilters={immFilters}
                    cardCurrency={cardCurrency || EURO_TEXT}
                    onCloseClick={this.handleToggleFilters}
                    flagBasedFeatures={flagBasedFeatures}
                    setFilters={this.setFilters}
                    showStateFilter={!showCardsDropdown}
                    minDateFilterAllowed={immTransactions.get('monthsBefore')}
                />
            );
        }

        return (
            <div className="card-last-movements">
                {modal}
                {innerComponent}
            </div>
        )
    }
}

CardLastMovements.propTypes = {
    cardTransactionsOutdated: PropTypes.func.isRequired,
    clearFilters: PropTypes.func.isRequired,
    downloadCardsTransactions: PropTypes.func.isRequired,
    flagBasedFeatures: PropTypes.object,
    immCard: PropTypes.object.isRequired,
    immCards: PropTypes.object,
    immCardsTransactionsDownload: PropTypes.object,
    immFilters: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immTransactions: PropTypes.object,
    requestCardTransactions: PropTypes.func.isRequired,
    requestNextCardTransactionsPage: PropTypes.func.isRequired,
    resetFilter: PropTypes.func.isRequired,
    setTransactionsFilters: PropTypes.func.isRequired,
    showCardsDropdown: PropTypes.bool,
    validateAndExecuteSagas: PropTypes.func.isRequired,
    resetScaForCardTransactionsDownload: PropTypes.func.isRequired
}

module.exports = CardLastMovements;
